import { Button, TextField, Typography } from '@mui/material';
import { BaseSyntheticEvent, FunctionComponent } from 'react';
import { FieldErrors, UseFormRegister } from 'react-hook-form';

export interface PlaceFormInputs {
  name: string;
  address: string;
}

interface PlaceFormProps {
  register: UseFormRegister<PlaceFormInputs>;
  onSubmit: (e?: BaseSyntheticEvent) => Promise<void>;
  errors: FieldErrors<PlaceFormInputs>;
  submitButtonLabel: string;
}

export const PlaceForm: FunctionComponent<PlaceFormProps> = ({
  register,
  onSubmit,
  errors,
  submitButtonLabel,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <TextField
        margin="normal"
        fullWidth
        id="name"
        label="Nom du lieu"
        placeholder='Ex: "Auberge de jeunesse de Rosière Près Troyes"'
        autoFocus
        type="text"
        {...register('name')}
        helperText={
          errors.name?.message ? (
            <Typography component="p" variant="body2" color="error.main">
              {errors.name.message}
            </Typography>
          ) : null
        }
      />
      <TextField
        margin="normal"
        multiline
        fullWidth
        label="Adresse"
        type="address"
        id="address"
        {...register('address')}
        helperText={
          errors.address?.message ? (
            <Typography component="p" variant="body2" color="error.main">
              {errors.address.message}
            </Typography>
          ) : null
        }
      />

      <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
        {submitButtonLabel}
      </Button>
    </form>
  );
};
